import React from 'react'
import PropTypes from 'prop-types'
import { useMsal, useAccount } from '@azure/msal-react'

import { loginRequest } from '../msalConfig'
import { Logger, LoggerTypes } from '../utils'
import { customAxios } from './customAxios'
import { InteractionRequiredAuthError } from '@azure/msal-browser'

const RequestInterceptor = ({ children, expiredTokenCallback }) => {
  const { instance, accounts } = useMsal()
  const account = useAccount(accounts[0])

  /**
   * Here we set a request interceptor to `customAxios` to populate
   * each call to the API through axios with the `Bearer XXXX` Authorization Header value
   * @see customAxios
   */
  customAxios.interceptors.request.use(async (config) => {
    Logger.trace(LoggerTypes.API, 'axios.interceptors.request()', { config, account })

    // TODO Auth active ?
    // acquireTokenSilent will check for token expiration and acquire a new one if needed
    const response = await instance
      .acquireTokenSilent({
        ...loginRequest,
        account
      })
      .catch((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          // fallback to interaction when silent call fails
          if (expiredTokenCallback !== null) {
            expiredTokenCallback()
          }

          return instance.acquireTokenRedirect(loginRequest)
        }
        Logger.trace(LoggerTypes.API, 'axios.interceptors.acquireTokenSilent()', { error })
        return null
      })

    Logger.trace(LoggerTypes.API, 'RequestInterceptor() > axios.interceptors.request.use(...)', {
      config,
      account,
      idToken: response.idToken,
      idTokenClaims: response.account.idTokenClaims,
      response
    })

    const bearer = `Bearer ${response.idToken}`
    config.headers.Authorization = bearer
    return config
  })

  return <>{children}</>
}

RequestInterceptor.displayName = 'RequestInterceptor'

RequestInterceptor.propTypes = {
  children: PropTypes.node,
  expiredTokenCallback: PropTypes.func
}

export default RequestInterceptor
